import classNames from "classnames";
import PropTypes from "prop-types";

const prefix = "m-progres-bar";

const colors = ["primary", "danger", "warning", "red-500"];

const ProgressBar = ({ className, progress = 0, max = 100, color = "primary" }) => {
  const componentClass = classNames(prefix, "w-full rounded-xl", {
    [className]: className
  });

  return (
    <div className={componentClass}>
      <div className="bg-gray-300 h-2">
        <div
          className={`${prefix}__progress h-full bg-${colors.includes(color) ? color : ``}`}
          style={{ 
            width: `${(max ? progress / max * 100 : 0).toFixed(2) }%`,
            backgroundColor: !colors.includes(color) ? color : ``
          }}
        ></div>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  color: PropTypes.string,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  progress: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default ProgressBar;
